import $ from 'cash-dom';
import lottie from 'lottie-web';

export default () => {
  const $carHeroLines = $('.js-hero-lines');
  const $carHeroShow = $('.js-hero-show');
  const url = window.script_data !== undefined
    ? `${window.script_data.urlTheme}/assets/other/`
    : './other/';

  if ($carHeroLines.length && $carHeroShow.length) {
    lottie.loadAnimation({
      container: $carHeroShow[0], // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: `${url}hero-r1.json`, // the path to the animation json
    });

    setTimeout(() => {
      $carHeroShow.parent().addClass('is-transparent');
    }, 550);

    setTimeout(() => {
      lottie.loadAnimation({
        container: $carHeroLines[0], // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: `${url}hero-r1-lines.json`, // the path to the animation json
      });
      $carHeroShow.parent().css('display', 'none');
    }, 1200);
  }
};
